export default __webpack_public_path__ + "static/media/detail_big_11_1.cc8f5fc7.jpg";